import { createStore } from "vuex";
import scheduling from "@/views/scheduling/store/index";
import login from "@/views/Login/store/index";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { scheduling, login },
});
